import styled, { css } from 'styled-components';
import boardSrc from 'assets/images/board.min.png';

export const SWrapper = styled.div<{ isPlaying: boolean }>`
  max-height: 660px;
  position: relative;
  padding: 60px 60px 90px;
  user-select: none;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-image: url('${boardSrc}');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top;
  }

  @media (max-width: 840px) and (max-aspect-ratio: 1/1) {
    padding: 60px 50px 80px;

    &:after {
      display: none;
    }
  }

  @media (max-width: 520px) and (max-aspect-ratio: 1/1) {
    padding: 50px 40px 70px;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    padding: 30px 20px 30px;
  }

  @media (max-width: 400px) and (max-aspect-ratio: 1/1) {
    padding: 30px 14px 30px;
  }

  @media (max-width: 320px) and (max-aspect-ratio: 1/1) {
    padding: 30px 14px 30px;
  }
`;

export const SInner = styled.div<{
  disabled: boolean;
  cellAnimDelay: string;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  height: 100%;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
    `}

  ${({ cellAnimDelay }) => cellAnimDelay}
`;
